/*
Autogenerated
Do not edit! 
 █████  ██    ██ ████████  ██████   ██████  ███████ ███    ██ ███████ ██████   █████  ████████ ███████ ██████  
██   ██ ██    ██    ██    ██    ██ ██       ██      ████   ██ ██      ██   ██ ██   ██    ██    ██      ██   ██ 
███████ ██    ██    ██    ██    ██ ██   ███ █████   ██ ██  ██ █████   ██████  ███████    ██    █████   ██   ██ 
██   ██ ██    ██    ██    ██    ██ ██    ██ ██      ██  ██ ██ ██      ██   ██ ██   ██    ██    ██      ██   ██ 
██   ██  ██████     ██     ██████   ██████  ███████ ██   ████ ███████ ██   ██ ██   ██    ██    ███████ ██████  
                                                                                                               
                                                                                                               
██████   ██████      ███    ██  ██████  ████████     ███████ ██████  ██ ████████ ██                            
██   ██ ██    ██     ████   ██ ██    ██    ██        ██      ██   ██ ██    ██    ██                            
██   ██ ██    ██     ██ ██  ██ ██    ██    ██        █████   ██   ██ ██    ██    ██                            
██   ██ ██    ██     ██  ██ ██ ██    ██    ██        ██      ██   ██ ██    ██                                  
██████   ██████      ██   ████  ██████     ██        ███████ ██████  ██    ██    ██                            
                                                                                                               
                                                                                                               
*/
            import { BibAssignGuiDef } from '@/objects/generated/gui';
import { BibAssignPreviewGuiDef } from '@/objects/generated/gui';
import { BibAssignSortGuiDef } from '@/objects/generated/gui';
import { CategoryGuiDef } from '@/objects/generated/gui';
import { CommunicationToApproveGuiDef } from '@/objects/generated/gui';
import { EventinfoBaseGuiDef } from '@/objects/generated/gui';
import { EventinfoGuiDef } from '@/objects/generated/gui';
import { EventinfoSearchlistItemGuiDef } from '@/objects/generated/gui';
import { EventinfoTextGuiDef } from '@/objects/generated/gui';
import { FISDataCategoryGuiDef } from '@/objects/generated/gui';
import { FISDataRaceGuiDef } from '@/objects/generated/gui';
import { FocusEventGuiDef } from '@/objects/generated/gui';
import { GPIOReadingGuiDef } from '@/objects/generated/gui';
import { GroupGuiDef } from '@/objects/generated/gui';
import { GroupWithCountGuiDef } from '@/objects/generated/gui';
import { HeatPlanGuiDef } from '@/objects/generated/gui';
import { LicenceSearchItemGuiDef } from '@/objects/generated/gui';
import { MapTrackGuiDef } from '@/objects/generated/gui';
import { ParticipantIDGuiDef } from '@/objects/generated/gui';
import { ParticipantGuiDef } from '@/objects/generated/gui';
import { RaceContestantCompleteGuiDef } from '@/objects/generated/gui';
import { RaceContestantDetailsGuiDef } from '@/objects/generated/gui';
import { RaceContestantPointsGuiDef } from '@/objects/generated/gui';
import { ContestantAndRaceContestantTimeGuiDef } from '@/objects/generated/gui';
import { RaceGuiDef } from '@/objects/generated/gui';
import { RelayTeamContestantGuiDef } from '@/objects/generated/gui';
import { ScoringGuiDef } from '@/objects/generated/gui';
import { SeriesGuiDef } from '@/objects/generated/gui';
import { ShootingResultGuiDef } from '@/objects/generated/gui';
import { StartingNumberGuiDef } from '@/objects/generated/gui';
import { StationAliasGuiDef } from '@/objects/generated/gui';
import { StationGuiDef } from '@/objects/generated/gui';
import { StationRoleGuiDef } from '@/objects/generated/gui';
import { TimepenaltyGuiDef } from '@/objects/generated/gui';
import { TrackingDeviceGuiDef } from '@/objects/generated/gui';
import { TrainingLaneGuiDef } from '@/objects/generated/gui';
import { UnknownTagGuiDef } from '@/objects/generated/gui';
import { defineStore } from 'pinia';
export const useGuiStore = defineStore('gui', () => {
    const BibAssign: BibAssignGuiDef = new BibAssignGuiDef();
    const BibAssignPreview: BibAssignPreviewGuiDef = new BibAssignPreviewGuiDef();
    const BibAssignSort: BibAssignSortGuiDef = new BibAssignSortGuiDef();
    const Category: CategoryGuiDef = new CategoryGuiDef();
    const CommunicationToApprove: CommunicationToApproveGuiDef = new CommunicationToApproveGuiDef();
    const EventinfoBase: EventinfoBaseGuiDef = new EventinfoBaseGuiDef();
    const Eventinfo: EventinfoGuiDef = new EventinfoGuiDef();
    const EventinfoSearchlistItem: EventinfoSearchlistItemGuiDef = new EventinfoSearchlistItemGuiDef();
    const EventinfoText: EventinfoTextGuiDef = new EventinfoTextGuiDef();
    const FISDataCategory: FISDataCategoryGuiDef = new FISDataCategoryGuiDef();
    const FISDataRace: FISDataRaceGuiDef = new FISDataRaceGuiDef();
    const FocusEvent: FocusEventGuiDef = new FocusEventGuiDef();
    const GPIOReading: GPIOReadingGuiDef = new GPIOReadingGuiDef();
    const Group: GroupGuiDef = new GroupGuiDef();
    const GroupWithCount: GroupWithCountGuiDef = new GroupWithCountGuiDef();
    const HeatPlan: HeatPlanGuiDef = new HeatPlanGuiDef();
    const LicenceSearchItem: LicenceSearchItemGuiDef = new LicenceSearchItemGuiDef();
    const MapTrack: MapTrackGuiDef = new MapTrackGuiDef();
    const ParticipantID: ParticipantIDGuiDef = new ParticipantIDGuiDef();
    const Participant: ParticipantGuiDef = new ParticipantGuiDef();
    const RaceContestantComplete: RaceContestantCompleteGuiDef = new RaceContestantCompleteGuiDef();
    const RaceContestantDetails: RaceContestantDetailsGuiDef = new RaceContestantDetailsGuiDef();
    const RaceContestantPoints: RaceContestantPointsGuiDef = new RaceContestantPointsGuiDef();
    const ContestantAndRaceContestantTime: ContestantAndRaceContestantTimeGuiDef = new ContestantAndRaceContestantTimeGuiDef();
    const Race: RaceGuiDef = new RaceGuiDef();
    const RelayTeamContestant: RelayTeamContestantGuiDef = new RelayTeamContestantGuiDef();
    const Scoring: ScoringGuiDef = new ScoringGuiDef();
    const Series: SeriesGuiDef = new SeriesGuiDef();
    const ShootingResult: ShootingResultGuiDef = new ShootingResultGuiDef();
    const StartingNumber: StartingNumberGuiDef = new StartingNumberGuiDef();
    const StationAlias: StationAliasGuiDef = new StationAliasGuiDef();
    const Station: StationGuiDef = new StationGuiDef();
    const StationRole: StationRoleGuiDef = new StationRoleGuiDef();
    const Timepenalty: TimepenaltyGuiDef = new TimepenaltyGuiDef();
    const TrackingDevice: TrackingDeviceGuiDef = new TrackingDeviceGuiDef();
    const TrainingLane: TrainingLaneGuiDef = new TrainingLaneGuiDef();
    const UnknownTag: UnknownTagGuiDef = new UnknownTagGuiDef();

    return {
        BibAssign,
        BibAssignPreview,
        BibAssignSort,
        Category,
        CommunicationToApprove,
        EventinfoBase,
        Eventinfo,
        EventinfoSearchlistItem,
        EventinfoText,
        FISDataCategory,
        FISDataRace,
        FocusEvent,
        GPIOReading,
        Group,
        GroupWithCount,
        HeatPlan,
        LicenceSearchItem,
        MapTrack,
        ParticipantID,
        Participant,
        RaceContestantComplete,
        RaceContestantDetails,
        RaceContestantPoints,
        ContestantAndRaceContestantTime,
        Race,
        RelayTeamContestant,
        Scoring,
        Series,
        ShootingResult,
        StartingNumber,
        StationAlias,
        Station,
        StationRole,
        Timepenalty,
        TrackingDevice,
        TrainingLane,
        UnknownTag,
    };
});
